import { React, useState } from "react";

import { Button } from "react-admin";

import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import ClonePageVersionsDialog from "./dialogs/ClonePageVersionsDialog";
import CloneComponentVersionsDialog from "./dialogs/CloneComponentVersionsDialog";

const CreateVersion = ({ record, resource, pageName, route, mode }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        label="Клонирай"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <ControlPointDuplicateIcon />
      </Button>

      {mode === "page" ? (
        <ClonePageVersionsDialog
          open={isOpen}
          close={() => setIsOpen(false)}
          record={record}
          resource={resource}
          pageName={pageName}
          route={route}
        />
      ) : (
        <CloneComponentVersionsDialog
          open={isOpen}
          close={() => setIsOpen(false)}
          record={record}
          resource={resource}
          route={route}
        />
      )}
    </>
  );
};

export default CreateVersion;
